import isEqual from 'lodash/isEqual';
import { MeetingDto, MeetingTopicDto } from 'src/api/FiretrolApiClient';

const stampOf = (value: Date | undefined) =>
  value == null ? 0 : new Date(value).getTime();

const byId = (topics: MeetingTopicDto[] | undefined) =>
  new Map((topics ?? []).map((topic) => [topic.id, topic]));

/**
 * Builds the tree a server read may reseed the form with. A topic edited in the
 * form since the last applied read is only replaced by a read stamped after the
 * copy that edit was made from: a read started before the edit's write can land
 * after it, and taking that row back would roll the edit off screen and send the
 * rolled-back value with the next topic write.
 */
export const mergeMeetingSnapshot = (
  next: MeetingDto,
  current: MeetingDto,
  applied: MeetingDto,
): MeetingDto => {
  if (next.topics == null) return next;

  const currentTopics = byId(current.topics);
  const appliedTopics = byId(applied.topics);

  const topics = (next.topics ?? []).map((topic) => {
    const local = currentTopics.get(topic.id);
    if (!local || isEqual(local, topic)) return topic;

    const base = appliedTopics.get(topic.id);
    const localIsEdited = base == null || !isEqual(local, base);
    if (!localIsEdited) return topic;

    return stampOf(topic.updatedAt) > stampOf(local.updatedAt) ? topic : local;
  });

  return { ...next, topics };
};
